import { render, staticRenderFns } from "./LeftDataBottom.vue?vue&type=template&id=f940c48a&"
import script from "./LeftDataBottom.vue?vue&type=script&lang=js&"
export * from "./LeftDataBottom.vue?vue&type=script&lang=js&"
import style0 from "./LeftDataBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports